import React from 'react';
import { PERCENTILE_COLORS, getItemTypeColor } from '../utils/chartUtils';

function Filters({ allTypes, visibleTypes, setVisibleTypes, visiblePercentiles, togglePercentile, getTypeColor }) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
  
  // Função para obter cor - usa a personalizada se fornecida, senão usa a padrão
  const getColor = getTypeColor || ((type) => getItemTypeColor(type, allTypes));
  
  // Verifica se há percentis para mostrar (Lead Time tem, Throughput não)
  const hasPercentiles = Object.keys(visiblePercentiles).length > 0;
  
  return (
    <div className={`flex w-full ${hasPercentiles ? 'justify-between' : 'justify-start'} mb-2`}>
      <div className="flex flex-wrap gap-2">
        {allTypes.map(type => (
          <button
            key={type}
            onClick={() => setVisibleTypes(v => v.includes(type) ? v.filter(t => t !== type) : [...v, type])}
            className={`px-3 py-1 rounded-full border transition-all ${isMobile ? 'text-xs' : 'text-sm'} font-medium ${visibleTypes.includes(type) ? '' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`}
            style={visibleTypes.includes(type) ? {
              backgroundColor: getColor(type),
              color: '#fff', fontWeight: 700
            } : {}}
          >
            {type}
          </button>
        ))}
      </div>
      {hasPercentiles && (
        <div className="flex flex-wrap gap-2">
          {['P50', 'P85', 'P95'].map(key => (
            <button
              key={key}
              onClick={() => togglePercentile(key)}
              className={`px-3 py-1 rounded-full border border-gray-300 transition-all ${isMobile ? 'text-xs' : 'text-sm'} font-medium ${visiblePercentiles[key] ? '' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`}
              style={visiblePercentiles[key] ? {
                backgroundColor: PERCENTILE_COLORS[key],
                color: '#fff', fontWeight: 700
              } : {}}
            >
              {key}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default Filters;
